<template>
  <div class="fixed inset-0 z-50 flex items-center justify-center p-4">
    <div class="absolute inset-0 bg-black/50" @click="$emit('close')" />

    <div class="relative bg-white dark:bg-slate-800 rounded-2xl shadow-2xl w-full max-w-md">
      <!-- Header -->
      <div class="flex items-center justify-between px-6 py-4 border-b border-slate-200 dark:border-slate-700">
        <h2 class="text-base font-semibold text-slate-800 dark:text-slate-100">
          {{ isEditing ? 'Editar coluna' : 'Nova coluna' }}
        </h2>
        <button
          class="p-1.5 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-700 text-slate-400 hover:text-slate-600"
          @click="$emit('close')"
        >
          <span class="i-lucide-x size-4" />
        </button>
      </div>

      <!-- Body -->
      <div class="px-6 py-4 space-y-4">
        <div>
          <label class="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">
            Nome <span class="text-red-500">*</span>
          </label>
          <input
            v-model="form.name"
            type="text"
            placeholder="Ex: Novo Lead, Em Negociação..."
            class="w-full px-3 py-2 text-sm border border-slate-200 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-900 text-slate-800 dark:text-slate-100 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-woot-500"
          />
        </div>

        <div>
          <label class="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">Cor</label>
          <div class="flex items-center gap-3">
            <input
              v-model="form.color"
              type="color"
              class="size-9 rounded-lg border border-slate-200 dark:border-slate-700 cursor-pointer"
            />
            <div class="flex gap-2 flex-wrap">
              <button
                v-for="color in presetColors"
                :key="color"
                class="size-6 rounded-full border-2 transition-transform hover:scale-110"
                :style="{ backgroundColor: color, borderColor: form.color === color ? '#6366f1' : 'transparent' }"
                @click="form.color = color"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- Footer -->
      <div class="flex items-center justify-between px-6 py-4 border-t border-slate-200 dark:border-slate-700">
        <button
          v-if="isEditing"
          class="px-4 py-2 text-sm text-red-500 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-lg transition-colors"
          @click="$emit('delete', stage)"
        >
          Excluir coluna
        </button>
        <div class="flex items-center gap-3 ml-auto">
          <button
            class="px-4 py-2 text-sm text-slate-600 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-700 rounded-lg transition-colors"
            @click="$emit('close')"
          >
            Cancelar
          </button>
          <button
            class="px-4 py-2 text-sm bg-woot-500 hover:bg-woot-600 text-white rounded-lg transition-colors disabled:opacity-50 flex items-center gap-2"
            :disabled="!form.name || isSaving"
            @click="handleSubmit"
          >
            <span v-if="isSaving" class="i-lucide-loader-2 size-3.5 animate-spin" />
            {{ isEditing ? 'Salvar' : 'Criar coluna' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue';

const props = defineProps({
  stage: { type: Object, default: null },
  isSaving: { type: Boolean, default: false },
});

const emit = defineEmits(['close', 'submit', 'delete']);

const isEditing = computed(() => !!props.stage?.id);

const presetColors = [
  '#6366f1', '#8b5cf6', '#ec4899', '#ef4444',
  '#f97316', '#eab308', '#22c55e', '#14b8a6',
  '#3b82f6', '#64748b',
];

const form = ref({ name: '', color: '#6366f1' });

watch(() => props.stage, (stage) => {
  form.value = {
    name: stage?.name || '',
    color: stage?.color || '#6366f1',
  };
}, { immediate: true });

function handleSubmit() {
  if (!form.value.name) return;
  emit('submit', { ...form.value });
}
</script>
